export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export const guessContentType = (fileName: string | undefined | null): string => {
  if (!fileName) return '';
  
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  
  switch (ext) {
    case 'pdf': return 'application/pdf';
    case 'png': case 'jpg': case 'jpeg': case 'gif': case 'bmp': case 'webp': case 'svg':
      return `image/${ext}`;
    case 'doc': case 'docx': return 'application/msword';
    case 'xls': case 'xlsx': case 'csv': return 'application/vnd.ms-excel';
    case 'zip': case 'rar': case '7z': return 'application/zip';
    case 'txt': case 'log': return 'text/plain';
    default: return '';
  }
}

export const getFileTypeInfo = (contentType: string) => {
  if (!contentType) {
    return { icon: 'i-heroicons-document-duplicate', color: 'text-gray-400', bg: 'bg-gray-100 dark:bg-gray-800' };
  }
  
  if (contentType.startsWith('image/')) {
    return { icon: 'i-heroicons-photo', color: 'text-blue-500', bg: 'bg-blue-50 dark:bg-blue-900/20' };
  }
  
  if (contentType === 'application/pdf') {
    return { icon: 'i-heroicons-document-text', color: 'text-red-500', bg: 'bg-red-50 dark:bg-red-900/20' };
  }
  
  if (contentType.includes('word') || contentType.includes('document')) {
    return { icon: 'i-heroicons-document-text', color: 'text-blue-600', bg: 'bg-blue-50 dark:bg-blue-900/20' };
  }
  
  if (contentType.includes('excel') || contentType.includes('sheet') || contentType.includes('csv')) {
    return { icon: 'i-heroicons-table-cells', color: 'text-green-600', bg: 'bg-green-50 dark:bg-green-900/20' };
  }
  
  if (contentType.includes('zip') || contentType.includes('archive') || contentType.includes('compressed')) {
    return { icon: 'i-heroicons-archive-box', color: 'text-amber-500', bg: 'bg-amber-50 dark:bg-amber-900/20' };
  }
  
  if (contentType.startsWith('text/')) {
    return { icon: 'i-heroicons-document', color: 'text-gray-500', bg: 'bg-gray-50 dark:bg-gray-800' };
  }
  
  return { icon: 'i-heroicons-document-duplicate', color: 'text-gray-400', bg: 'bg-gray-100 dark:bg-gray-800' };
}
